import "twin.macro";

import { MoreVert } from "@mui/icons-material";
import { IconButton, MenuItem } from "@mui/material";

import OptionsMenu from "@components/Utility/OptionsMenu";
import {
  DemandPlanVariant,
  DemandPlanVariantStatus,
  canTransition,
} from "@models/DemandPlanVariant";

import { useUpdateDemandPlanVariantMutation } from "../../data/demandPlanVariantQueries";

export const ActionMenu = ({
  demandPlanVariant: dpv,
}: {
  demandPlanVariant: DemandPlanVariant;
}) => {
  const updateMutation = useUpdateDemandPlanVariantMutation();

  const canTransitionToPendingReview = canTransition(
      dpv,
      DemandPlanVariantStatus.PendingReview
    ),
    canTransitionToReady = canTransition(
      dpv,
      DemandPlanVariantStatus.ReadyForPurchase
    ),
    canTerminate = canTransition(dpv, DemandPlanVariantStatus.Terminated),
    hasMenuOptions =
      canTransitionToPendingReview || canTransitionToReady || canTerminate;

  //TODO provide a form of animation when operations are performing?
  return (
    <OptionsMenu
      tw="align-middle"
      title={hasMenuOptions ? "Actions" : "No Actions"}
      disabled={!hasMenuOptions}
      component={(props) => (
        <IconButton
          {...props}
          tw="-my-2"
          onClick={(e) => {
            e.stopPropagation();
            props.onClick(e);
          }}
        >
          <MoreVert />
        </IconButton>
      )}
    >
      {/* Item needs further review */}
      {canTransitionToPendingReview && (
        <MenuItem
          onClick={() => {
            updateMutation.mutate({
              id: dpv.id,
              status: DemandPlanVariantStatus.PendingReview as string,
            });
          }}
        >
          Mark Pending
        </MenuItem>
      )}
      {/* Item has been reviewed and is marked as ready */}
      {canTransitionToReady && (
        <MenuItem
          onClick={() => {
            updateMutation.mutate({
              id: dpv.id,
              status: DemandPlanVariantStatus.ReadyForPurchase as string,
            });
          }}
        >
          Ready for Purchase
        </MenuItem>
      )}
      {/* Can mark the item as terminated so it cannot be ordered */}
      {canTerminate && (
        <MenuItem
          tw="text-red-600"
          onClick={() => {
            updateMutation.mutate({
              id: dpv.id,
              status: DemandPlanVariantStatus.Terminated as string,
            });
          }}
        >
          Terminate
        </MenuItem>
      )}
    </OptionsMenu>
  );
};
